export enum DatasetAutomationTriggerType {
  DatasetRecordsCreated = 'DatasetRecordsCreated',
  DatasetRecordsUpdated = 'DatasetRecordsUpdated',
  DatasetRecordsDeleted = 'DatasetRecordsDeleted',
  DatasetRecordsSynced = 'DatasetRecordsSynced',
  ContentGeneratorLinkedToSchema = 'ContentGeneratorLinkedToSchema',
  ContentGeneratorUpdated = 'ContentGeneratorUpdated',
}

export const DatasetAutomationDatasetRecordTriggers = [
  DatasetAutomationTriggerType.DatasetRecordsCreated,
  DatasetAutomationTriggerType.DatasetRecordsUpdated,
  DatasetAutomationTriggerType.DatasetRecordsDeleted,
  DatasetAutomationTriggerType.DatasetRecordsSynced,
  DatasetAutomationTriggerType.ContentGeneratorLinkedToSchema,
  DatasetAutomationTriggerType.ContentGeneratorUpdated,
] as const;

export enum DatasetAutomationActionType {
  ContentGeneratorLinkedToSchema = 'ContentGeneratorLinkedToSchema',
  GenerateContent = 'GenerateContent',
  ContentSync = 'ContentSync',
  UpdateGeneratedContent = 'UpdateGeneratedContent',
}
